export default __webpack_public_path__ + "static/second-line-beb1d5e49b7cc454e4462ad6fac24d81.svg";